/* Heymommies · productpagina-look
   Pijltjes in de fotogalerij op mobiel en de videorij in de koopkolom, direct onder het 30-dagenblok.
   Zelfde gedrag als de Flow Lite (hm-bundle.js), zonder de kolf-specifieke variantkaarten en voorraadteller. */
(function(){
  function gallery(){
    var wrap=document.querySelector('.product-gallery__media-list-wrapper');
    var car=document.querySelector('.product-gallery__media-list');
    if(!wrap||!car||wrap.querySelector('.hm-gnav')) return;
    if(car.querySelectorAll('.product-gallery__media:not([hidden])').length<2) return;
    function mk(dir,lbl,d){
      var b=document.createElement('button');
      b.type='button';b.className='hm-gnav hm-gnav--'+(dir<0?'prev':'next');b.setAttribute('aria-label',lbl);
      b.innerHTML="<svg viewBox='0 0 24 24'><path d='"+d+"'></path></svg>";
      b.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();var w=car.clientWidth||car.getBoundingClientRect().width;car.scrollBy({left:dir*w,behavior:'smooth'});});
      return b;
    }
    wrap.appendChild(mk(-1,'Vorige','M14.5 7l-5 5 5 5'));
    wrap.appendChild(mk(1,'Volgende','M9.5 7l5 5-5 5'));
  }
  function videos(){
    var vs=document.querySelector('.hm-vid'),gar=document.querySelector('.hm-gar');
    if(!vs||!gar) return;
    var vsec=vs.closest('[id^="shopify-section"]')||vs;
    var host=gar.closest('.product-info__block-item')||gar.parentElement;
    if(!host||!host.parentNode) return;
    vs.classList.add('hm-vid--incol');
    if(host.nextElementSibling!==vsec) host.parentNode.insertBefore(vsec,host.nextSibling);
  }
  function run(){try{gallery();}catch(e){}try{videos();}catch(e){}}
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded',run);
  window.addEventListener('load',run);
  document.addEventListener('shopify:section:load',function(){setTimeout(run,60);});
})();
